import { Intakes } from '../intakes/Intakes';

export const IntakesPage = () => {
  return (
    <div className="w-full">
      <Intakes />
    </div>
  );
};
